var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLikeSolid = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 7.212c0-.92-.746-1.667-1.667-1.667h-4.207a.166.166 0 0 1-.158-.218 5.8 5.8 0 0 0 .347-2.938C9.923.989 9.092.589 8.443.679a1.334 1.334 0 0 0-1.11 1.366c0 1.831-1.419 3.831-2.689 4.708a.33.33 0 0 0-.144.274v6.744c0 .16.113.297.27.328.238.045.454.09.658.133.897.213 1.817.319 2.739.314H12.5c1.305 0 1.5-.733 1.5-1.167 0-.23-.053-.456-.154-.663a1.5 1.5 0 0 0 .667-2 1.5 1.5 0 0 0 .639-2.052c.524-.295.848-.85.848-1.452M3.5 7.045a.667.667 0 0 0-.667-.666H.667A.667.667 0 0 0 0 7.045v7.334c0 .368.299.666.667.666h2.166a.667.667 0 0 0 .667-.666zM2 13.712a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 7.212c0-.92-.746-1.667-1.667-1.667h-4.207a.166.166 0 0 1-.158-.218 5.8 5.8 0 0 0 .347-2.938C9.923.989 9.092.589 8.443.679a1.334 1.334 0 0 0-1.11 1.366c0 1.831-1.419 3.831-2.689 4.708a.33.33 0 0 0-.144.274v6.744c0 .16.113.297.27.328.238.045.454.09.658.133.897.213 1.817.319 2.739.314H12.5c1.305 0 1.5-.733 1.5-1.167 0-.23-.053-.456-.154-.663a1.5 1.5 0 0 0 .667-2 1.5 1.5 0 0 0 .639-2.052c.524-.295.848-.85.848-1.452M3.5 7.045a.667.667 0 0 0-.667-.666H.667A.667.667 0 0 0 0 7.045v7.334c0 .368.299.666.667.666h2.166a.667.667 0 0 0 .667-.666zM2 13.712a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1",
    clipRule: "evenodd"
  })));
});
export default SvgIconLikeSolid;
export const raw = __webpack_public_path__ + "static/media/IconLikeSolid.8fce3d619fefa8f937da8cf08928ba10.svg";